<template>
    <div>
        <template v-if="totalSteps">

            <pm-pdf-jaw-header
                :title="$t('plan_calculator.' + jaw) + ': ' + title"
                :price="$store.state.simplePlan[jaw + 'JawTotal']"
            />

            <table cellpadding="0" cellspacing="0" border="0" style="width: 100%;">
                <template v-for="(option, key) in options" v-if="option!==null" >

                    <pm-pdf-treatment-step-package
                        v-if="option.tpl"
                        :amount="option.amount"
                        :unit-price="option.price"
                        :tooth-ids="option.tooth_id"
                    >

                        <template v-if="['full_jaw_6_12', 'full_jaw_6_14', 'full_jaw_8_12', 'full_jaw_8_14'].includes(option.tpl)">
                            <span slot="title">
                                {{ getOptionTitle(option) }}
                            </span>
                            <span slot="amount">
                                Package price
                            </span>
                        </template>
                        <template v-else>
                            <span slot="title">
                                {{ $t('plan_calculator.state_' + key) }}: {{ getOptionTitle(option) }}
                            </span>
                        </template>
                    </pm-pdf-treatment-step-package>

                    <pm-pdf-treatment-step
                        v-else
                        :title="$t('plan_calculator.state_' + key) + ': ' + getOptionTitle(option)"
                        :amount="option.amount"
                        :unit-price="option.price / option.amount"
                        :tooth-ids="option.tooth_id"
                    />
                </template>
            </table>
            <br/>
        </template>
    </div>
</template>

<script>
import PmTreatmentOverview from "./treatment-overview";
import PmPdfTreatmentStep from "../pdf/treatment-step.vue";
import PmPdfTreatmentStepPackage from "../pdf/treatment-step-package.vue";
import PmPdfJawHeader from "../pdf/jaw-header.vue";

export default {
    extends: PmTreatmentOverview,
    components: {
        PmPdfTreatmentStep,
        PmPdfTreatmentStepPackage,
        PmPdfJawHeader,
    }
};
</script>
